export const dateSort = (array: any[]): any => {
  return array?.sort((a, b) => {
    return new Date(b?.createdDate) - new Date(a?.createdDate);
  });
};
